import { REFERRAL_TRIGGER_WORD } from '../../../constants/task';
import { useQuestFlags } from './useQuestFlags';

export const useModifiedDescription = ({ quest }) => {
  const { uid, isComplete, description, button_link } = quest;
  const { isGuessTask } = useQuestFlags({ quest });

  return (() => {
    if (isComplete || !isGuessTask) return description;

    const triggeredWord = REFERRAL_TRIGGER_WORD[uid];

    return !triggeredWord || !button_link
      ? description
      : description.replace(triggeredWord, `<a target="_blank" href=${button_link}>${triggeredWord}</a>`);
  })();
};
